"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.node.isRequired,
  error: _propTypes.bool
} : {};

const selectColor = (theme, error) => {
  if (error) {
    return theme.colorFeedbackError;
  }

  return theme.colorNeutral60;
};

const style = ({
  theme,
  error
}) => (0, _stylitas.css)`
  display: flex;
  align-itens: center;
  justify-content: center;
  margin: 0 4px;
  color: ${selectColor(theme, error)};
  ${_styleUtilities.typography.sm(theme)}
`;

const MessageStyled = _stylitas.styled.p`
  ${style}
`;

const Message = ({
  children,
  error = false
}) => (0, _core.jsx)(MessageStyled, {
  error: error,
  "data-testid": "message"
}, children);

exports.Message = Message;
process.env.NODE_ENV !== "production" ? Message.propTypes = propTypes : void 0;
Message.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Message",
  "props": {
    "error": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};